import React from "react";
import "../component/Landing.css"
import { MdOutlineMessage } from "react-icons/md";
import { PiPhonePauseFill } from "react-icons/pi";
import { BiLogoGmail } from "react-icons/bi";
import { FaWhatsapp } from "react-icons/fa6";

const FloatingContact = () =>{
    const handleContactDisplay = () => {
        const whatsapp = document.querySelector("li.icon.whatsapp")
        const phone = document.querySelector("li.icon.phone")
        const gmail = document.querySelector("li.icon.gmail")

        whatsapp.style.top = whatsapp.style.top === "0px" ? "165px" : "0px";
        phone.style.top = phone.style.top === "0px" ? "55px" : "0px";
        gmail.style.top = gmail.style.top === "0px" ? "110px" : "0px";
    }
    return(
        <div className="landing_contact">
        <a href="https://wa.me/+2347070708909?text=Hello%20Geoinfo%20Academy,%20I’m%20interested%20in%20your%20training%20programs"><li className="icon whatsapp"><FaWhatsapp /></li></a>
        <a href="mailto:Training@geoinfotech.ng"><li className="icon gmail"><BiLogoGmail /></li></a>
        <a href="tel:+2347070708909?text=Hello%20Geoinfo%20Academy,%20I’m%20interested%20in%20your%20training%20programs"><li className="icon phone"><PiPhonePauseFill /></li></a>
        <button onClick={handleContactDisplay}><li className="icon blue" ><MdOutlineMessage /></li></button>
    </div>
    )
}

export default FloatingContact